import "./auth-shell.scss";

import { LocalProfile } from "@core/model/local-profile";
import { ApiToFormService } from "@core/services/api-to-form.service";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { PROFILE } from "@core/utility/settings";
import { GetResponsePersonModel } from "@factory/model/query-model-person";
import { useQyGetPerson } from "@factory/query/person.query";
import StorageService from "@shared/services/storage.service";
import { SpeedDial } from "primereact/speeddial";
import { Tooltip } from "primereact/tooltip";
import { Outlet, useNavigate } from "react-router-dom";

import { appConfig } from "../../../app.config";
import { appFeature } from "../../../app.feature";
import { useAuthShellNavigation } from "./auth-shell-navigation";

export function AuthShell() {
  const navigate = useNavigate();
  const { getAuthUser } = useUserIdentityContext();
  const logo = `${
    appConfig.assetPath
  }/icon-192x192.png?${new Date().toISOString()}`;
  const { headerElement, navigationElement } = useAuthShellNavigation(
    logo,
    appFeature.company
  );
  const { userCode } = getAuthUser();

  // PERSON API
  const handlePersonSuccess = (response: GetResponsePersonModel) => {
    const responseData = response.data ?? [];
    if (responseData.length === 0) {
      return;
    }

    const mappedData = ApiToFormService.MapProfile(responseData[0]);
    StorageService.save<LocalProfile>(PROFILE, mappedData);
  };
  useQyGetPerson(
    "",
    1,
    0,
    undefined,
    { code: userCode },
    !!userCode,
    handlePersonSuccess
  );

  const items = [
    {
      label: "Redeem",
      icon: "pi pi-star-fill",
      command: () => {
        navigate("/business/campaign/redeem-code");
      },
    },
    {
      label: "Custom Redeem",
      icon: "pi pi-gift",
      command: () => {
        navigate("/business/campaign/redeem-custom");
      },
    },
    {
      label: "Earn",
      icon: "pi pi-cart-minus",
      command: () => {
        navigate("/business/earn");
      },
    },
    {
      label: "Check",
      icon: "pi pi-user",
      command: () => {
        navigate("/business/check-profile");
      },
    },
  ];

  return (
    <div id="AuthShell" className="auth-shell">
      {headerElement}

      <section className="flex mt-4">
        {navigationElement}

        <div className="fixed bottom-[300px] right-[70px] z-50">
          <Tooltip
            target=".speeddial-bottom-right .p-speeddial-action"
            position="left"
          />

          <SpeedDial
            model={items}
            direction="up"
            className="speeddial-bottom-right"
            buttonClassName="p-button-danger"
          />
        </div>

        <section className="flex-1 bg-gray-50 rounded-lg mr-4 ml-4 md:ml-0 overflow-y-auto">
          <Outlet />
        </section>
      </section>
    </div>
  );
}

export default AuthShell;
